// src/pages/LoginPage.jsx
import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

export default function LoginPage() {
  const { signInWithGoogle } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    setError(''); setLoading(true);
    try {
      await signInWithGoogle();
    } catch (err) {
      setError('Sign-in failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--gray-100)', padding: '24px',
    }}>
      <div style={{
        background: '#fff', borderRadius: '16px', padding: '48px 40px',
        width: '100%', maxWidth: '400px', border: '1px solid var(--gray-200)',
        textAlign: 'center',
      }}>
        {/* Logo */}
        <div style={{
          width: '56px', height: '56px', background: 'var(--blue)',
          borderRadius: '14px', display: 'flex', alignItems: 'center',
          justifyContent: 'center', margin: '0 auto 20px',
          color: '#fff', fontWeight: '800', fontSize: '18px',
        }}>GS</div>

        <h1 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '6px' }}>
          GACH SERVICES LTD
        </h1>
        <p style={{ fontSize: '13px', color: 'var(--gray-500)', marginBottom: '32px' }}>
          Logistics Monitoring System — Team Portal
        </p>

        {error && (
          <div className="alert danger" style={{ marginBottom: '16px', textAlign: 'left' }}>
            {error}
          </div>
        )}

        <button
          onClick={handleSignIn}
          disabled={loading}
          style={{
            width: '100%', padding: '12px 20px',
            border: '1px solid var(--gray-200)', borderRadius: '8px',
            background: '#fff', cursor: loading ? 'not-allowed' : 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: '12px', fontSize: '14px', fontWeight: '600',
            color: 'var(--gray-900)', opacity: loading ? .6 : 1,
            transition: 'background .15s',
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'var(--gray-50)'}
          onMouseLeave={e => e.currentTarget.style.background = '#fff'}
        >
          {/* Google icon SVG */}
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 002.38-5.88c0-.57-.05-.66-.15-1.18z"/>
            <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 01-7.18-2.54H1.83v2.07A8 8 0 008.98 17z"/>
            <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 010-3.04V5.41H1.83a8 8 0 000 7.18l2.67-2.07z"/>
            <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 001.83 5.4L4.5 7.49a4.77 4.77 0 014.48-3.3z"/>
          </svg>
          {loading ? 'Signing in…' : 'Sign in with Google'}
        </button>

        <p style={{ fontSize: '11px', color: 'var(--gray-500)', marginTop: '24px' }}>
          Use your GACH SERVICES Google account.<br />
          Access is granted by your administrator.
        </p>
      </div>
    </div>
  );
}
